import * as React from 'react'
import { useParams } from 'react-router-dom';
import MetricChart from './MetricChart.js';
import metrics from './metrics.js'


const MetricPage = () => {

  const { id } = useParams();

  const metric = metrics.find(m => m.slug === id);

  return (
    <div>
      
      <div className="container mx-auto max-w-4xl pb-20">

        {/* Navigation header */}
        <div className="md:mb-6 lg:mb-6 py-4 flex justify-between items-top">
          
          {/* Back */}
          <div>
            <a href="/" className="rounded-xl p-2 hover:bg-gray-100 text-gray-300 -ml-2 text-sm font-regular">
              <span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-4 w-4 inline mr-1 mb-0.5">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              </span>
              <span>back to all policies</span>
            </a>
          </div>
          
          {/* Campaign site */}
          <div>
            <a href="https://www.kgfornyc.com" className="rounded-xl p-2 hover:bg-gray-100 text-gray-300 -mr-2 text-sm font-regular">
              campaign website
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-4 w-4 inline ml-1 mb-0.5">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </span>
            </a>
          </div>    
        </div>
        {/* end of navigation header */}

        <div className="text-6xl font-bold tracking-tight pb-6">
          <div>Kathryn's plan to</div>
          <div className="text-right text-darkblue tracking-tighter">{metric.headerName}</div>
        </div>

        <div className="text-lg">
          <div>We're putting {metric.sayInPlaceInsteadOfForward ? 'in place' : 'forward'} {metric.policies.length} big policies that will <span className="font-semibold">{metric.impactSummary}</span> over her first term.</div>
          <div>
            <ul className="list-inside list-disc">
              {metric.policies.map(p => {
                return (
                  <li key={p.name} className="px-2 py-1 rounded-xl">{p.name}</li>
                )
              })}
            </ul>
          </div>
        </div>

        <div className="mt-8 mb-16">
          <MetricChart metric={metric} />
        </div>

        {metric.underChartText && 
          <div>
            <div>{metric.underChartText}</div>
          </div>
        }

        {/* Policy Details */}
        {metric.details && metric.details.length > 0 && 
          <div>

            <div className="my-8 text-4xl text-gray-300 font-black">
              Policy Details
            </div>

            <div>
              {metric.details.map((blob, index) => {

                const renderFootnote = (link) => (
                  <div className="text-xs text-gray-400 my-1" key={link}>
                    <a href={link} className="underline">{link}</a>
                  </div>
                )

                const footnotes = []; 
                if (blob.footnoteLinks) {
                  footnotes.push(...blob.footnoteLinks)
                }
                if (blob.footnoteLink) {
                  footnotes.push(blob.footnoteLink)
                }

                console.log(footnotes);

                return (
                  <div key={index} className="my-8">
                    <div className="my-1 flex items-baseline justify-start">
                      <div className="font-bold text-lg mr-4">{blob.header}</div>
                    </div>
                    <div className="my-1">{blob.text}</div>
                    {footnotes.map(renderFootnote)}
                  </div>
                )
              })}
            </div>
          </div>
        }
      </div>

      {/* Footer */}
      <div className="h-40 bg-gray-100">

        <div className="h-full container mx-auto max-w-4xl  flex justify-between items-center text-gray-500">
          <div>Copyright © 2021 KGforNYC</div>
          <div>👋 made with love in brooklyn</div>
        </div>
    
      </div>

    </div>
  )
}

export default MetricPage;